import { Component, OnInit } from '@angular/core';
import {IEltern} from "../../models/IEltern.interface";
import {ElternService} from "../../service/eltern.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {SelectElternComponent} from "./select-eltern/select-eltern.component";
import {CreateElternComponent} from "./create-eltern/create-eltern.component";
import {IKind} from "../../models/IKind.interface";
import {CreateKindComponent} from "./create-kind/create-kind.component";
import {SelectKindComponent} from "./select-kind/select-kind.component";
import {Router} from "@angular/router";

@Component({
  selector: 'app-schnellbuchen',
  templateUrl: './schnellbuchen.component.html',
  styleUrls: ['./schnellbuchen.component.scss']
})
export class SchnellbuchenComponent implements OnInit {

  public eltern?: IEltern
  public kind?: IKind

  constructor(
      private elternService: ElternService,
      private modalService: NgbModal,
      private router: Router
  ) { }

  ngOnInit(): void {
  }

  selectEltern(): void {
    this.modalService.open(SelectElternComponent, {size: "lg"}).result.then(
        (result) => {
          console.log(`Geschlossen mit: ${result}`);
          this.eltern = result;
          if (this.kind && this.eltern && this.kind.eltern && this.kind.eltern.id !== this.eltern.id) {
            this.kind = undefined;
          }
        },
        (reason) => {
          console.log(`Abgebrochen`);
        }
    );
  }

  createEltern(): void {
    this.modalService.open(CreateElternComponent, {
        backdrop: "static",
    }).result.then(
        (result) => {
          this.eltern = result;
          this.kind = undefined;
          console.log(`Geschlossen mit: ${result}`);
        },
        (reason) => {
          console.log(`Abgebrochen`);
        }
    );
  }

  selectKind(): void {
    if (!this.eltern) {
      return;
    }
    const modalRef = this.modalService.open(SelectKindComponent, {size: "lg"});
    modalRef.componentInstance.eltern = this.eltern;
    modalRef.result.then(
        (result) => {
          this.kind = result;
          console.log(`Geschlossen mit: ${result}`);
        },
        (reason) => {
          console.log(`Abgebrochen`);
        }
    );
  }

  createKind(): void {
    if (!this.eltern) {
      return;
    }
    const modalRef = this.modalService.open(CreateKindComponent, {size: "lg", backdrop: "static"});
    modalRef.componentInstance.eltern = this.eltern;
    modalRef.result.then(
        (result) => {
          this.kind = result;
          console.log(`Geschlossen mit: ${result}`);
        },
        (reason) => {
          console.log(`Abgebrochen`);
        }
    );
  }

  clearEltern(): void {
    this.eltern = undefined;
    this.kind = undefined;
  }

  clearKind(): void {
    this.kind = undefined;
  }

  goToBuchung(): void {
    if (!this.kind) {
      return;
    }
    this.router.navigate(["/anmelden/kindBuchen", this.kind.id]);
  }

}
